import { connect } from "react-redux";
import DocumentEditBase from "../components/DocumentEdit/DocumentEditBase";

const mapStateToProps = (state) => ({
  user: state.login.user,
  menuData: state.menu.menuData,
});

export default connect(mapStateToProps)(DocumentEditBase);
